export default "__VITE_ASSET__CvoDTRpI__"